import axiosInstance from "axios";
import store from "./store";
import { setLoading } from "./actions";

const axios = axiosInstance.create({
  baseURL: "https://evaluacionprofesores.cuc.edu.co:4000",
  // baseURL: "https://evaluacionprofesores.cuc.edu.co/api",
  // baseURL: "http://localhost:4000",
});

let requestCount = 0;

const increment = () => {
  requestCount++;
  store.dispatch(setLoading(true));
};

const decrement = () => {
  requestCount--;
  if (requestCount <= 0) {
    requestCount = 0;
    store.dispatch(setLoading(false));
  }
};

// Request Interceptor
axios.interceptors.request.use(
  (config) => {
    increment();
    return config;
  },
  (error) => {
    decrement();
    return Promise.reject(error);
  },
);

// Response Interceptor
axios.interceptors.response.use(
  (response) => {
    decrement();
    return response;
  },
  (error) => {
    decrement();
    return Promise.reject(error);
  },
);

export default axios;
